export const BACKGROUND_IMAGE_SELECTED = 'BACKGROUND_IMAGE_SELECTED';



// WEBPACK FOOTER //
// ./src/redux/action-types/ui/backgroundImageSelected.js